import { Component} from '@angular/core';
import { EmployeeService } from '../employee.service';
import {HttpResponse, HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms'
//import {RequestOptions} from '@angular/common/http';

@Component({
 selector: 'app-uploadinventory',
 templateUrl: './uploadinventory.component.html',
  styleUrls: ['./uploadinventory.component.css']
})
export class UploadinventoryComponent {

  selectedFiles: FileList;
	currentFile: File;
  progress = 0;
  message = '';

    constructor(private fileService: EmployeeService) {}
	
  selectFile(event) {
    this.selectedFiles = event.target.files;
  }
  
  
  upload(): void {
    this.progress = 0;

    this.currentFile = this.selectedFiles.item(0);
    this.fileService.uploadFile(this.currentFile).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
          console.log(`Uploaded! ${this.progress}%`);
        } 
        else if (event instanceof HttpResponse) {
          this.message = 'File Uploaded Succesfuly!';
        }
      },
      err => {
        this.progress = 0;
        this.message = 'Could not upload the file!';
        this.currentFile = undefined;
      });

    this.selectedFiles = undefined;
  }
  refresh(): void {
    window.location.reload();
}
}
